






















import { Component, Vue, Prop } from 'vue-property-decorator';
import {curNfreshClient, NfreshClient} from '@/services/NfreshClient';

import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import ConfirmedAction from '@/components/ConfirmedAction.vue';
import { Subscription } from '@/types/core-push';

@Component({
  components: {
    VueError,
    Success,
    ConfirmedAction
  },
})
export default class DeleteSub extends Vue {

  @Prop({ default: {},  type: Object}) sub!: Subscription;

  error:string = '';
  success:string = '';

  private nfreshClient:NfreshClient = curNfreshClient;
  
  
  async deleteSubscription() {

    const reply = await this.nfreshClient.deleteSub({subId:this.sub.subscriptionId});
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to delete subscription: ${reply.errorMsg}`;
    
    this.setSuccess(`Subscription ${this.sub.subscriptionId} has been deleted`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
